import React from 'react';
import styles from './steps.module.scss';

interface StepHeadingProps {
    title: string;
    description: string;
}

export const StepHeading: React.FC<StepHeadingProps> = ({ title, description }) => (
    <div className={styles.heading}>
        <h2>{title}</h2>
        <p>{description}</p>
    </div>
);

export default StepHeading;
